import Ext from "Ext";
import $ from "jquery";
import DropdownButton from "../at_dropdown_button";
import {scrollWindowIfNeeded} from "../../atBrowserUtils";

/**
 * Drop-down button intended for use with hierarchy selector panels.
 * Creates single instance of the menu for each type of the selector
 * and the reuses it
 *
 * almost duplicates {@link AT.SelectorDropdownButton}
 * Depends on:
 * <code>/js/controls/at_dropdown_button.js</code>
 *
 * @cfg {AT.SelectorPanel} selectorPanel hierarchy selector panel to be displayed in dropdown (required).
 * @constructor
 */
const HierarchySelectorDropdownButton = Ext.extend(DropdownButton, {
    
    /**
     * @cfg {Number} specifies selector panel height. Is used to adjust menu align properly whether it is drop UP or DOWN
     */
    selectorPanelHeight: 350,
    selectorPanel: null,

    /**
     * @cfg {AT.SharedUserButtonMenu} menu specifies menu with hierarchy selector for the button
     */
    menu: null,
    labelCls: "ellipsis",
    cls: "dropdown-button at-selector-button",
    errorCls: "error",
    disabledCls: "disabledButton",
    plainTextCls: "plainCpText",

    dropDownMenuAnchor: "td.bottom-left-cell",
    dropUpMenuAnchor: "td.top-left-cell",

    innerTooltipsEnabled: false,
    getInnerTooltipTextCallback: null,

    enabled: true,
    plainTextMode: false,

    permitToShowCallback: function() {return true},

    constructor: function(config) {
        if (config.additionalCls)
        {
            this.cls += " " + config.additionalCls;
        }
        this.selectorPanel = config.menu.getSelectorPanel();
        HierarchySelectorDropdownButton.superclass.constructor.call(this, config);
    },

    setEnabled: function(enabled) {
        this.enabled = enabled;
        if (enabled) {
            this.removeClass(this.disabledCls);
        } else {
            this.addClass(this.disabledCls);
        }
    },

    getEnabled: function() {
      return this.enabled;
    },

    setPlainTextMode: function(plainTextMode) {
        this.plainTextMode = plainTextMode;
        if (plainTextMode) {
            this.addClass(this.plainTextCls);
        } else {
            this.removeClass(this.plainTextCls);
        }
    },

    initComponent: function() {
            HierarchySelectorDropdownButton.superclass.initComponent.call(this);

            this.selectorPanel.on("change", this.menu.makeHandlerForSpecificParent(this, this.updateButton), this);

            Ext.EventManager.on(window, "resize", this.menu.hide, this.menu);

            this.menu.setCurrentParent(this, true);

            this.onMenuShow = this.menu.makeHandlerForSpecificParent(this, this.onMenuShow);
            this.onMenuHide = this.menu.makeHandlerForSpecificParent(this, this.onMenuHide);
        },

        afterRender: function() {
            HierarchySelectorDropdownButton.superclass.afterRender.call(this);
            this.el.child("span:first").addClass(this.labelCls);
        },

        /**
         * Updates text label on the button.
         * @private
         */
        updateButton: function() {
            this.setText(this.selectorPanel.getLabelText(this.id));
            this.setDisplayInputError(false);
            this.setInnerTooltipsEnabled(this.selectorPanel.isInnerTooltipsEnabled());
            this.setTooltipEnabled(!this.innerTooltipsEnabled && this.selectorPanel.isTooltipEnabled());
            //we don't need inner tooltips of DropdownControl, now we need own inner tooltips of this button
            this.clearGetInnerTooltipCallback();
        },

        setInnerTooltipsEnabled : function ( enabled ) {
            this.innerTooltipsEnabled = enabled;
        },

        showTooltipEnabled : function() {
            return this.tooltipObject && this.tooltipEnabled && !this.innerTooltipsEnabled;
        },

        showInnerTooltip : function(element, isForTopLevelEntity) {
            if (this.tooltipObject && this.innerTooltipsEnabled) {
                var text = this.getInnerTooltipTextCallback ? this.getInnerTooltipTextCallback(isForTopLevelEntity) : this.selectorPanel.getPartialTooltipText(isForTopLevelEntity);
                this.doShowTooltip(text, element);
            }
        },

        /**
         * Replaces get inner tooltips text from selector panel to get it from passed callback(intended for DropdownControl)
         * @param callback function returns text inner tooltip for users and groups
         */
        setGetInnerTooltipCallback : function(callback) {
            this.getInnerTooltipTextCallback = callback;
        },

        clearGetInnerTooltipCallback : function() {
            this.getInnerTooltipTextCallback = null;
        },

        setPermitToShowCallback : function(callback) {
            this.permitToShowCallback = callback;
        },

        showMenu: function() {
            if (this.enabled && !this.plainTextMode && this.permitToShowCallback())
            {
                var dropDownAnchor = this.el.child(this.dropDownMenuAnchor);
                var dropUpAnchor = this.el.child(this.dropUpMenuAnchor);
                var yShift = dropDownAnchor.getTop() - dropUpAnchor.getTop();
                var enoughTopSpace = ( dropUpAnchor.getTop() - this.selectorPanelHeight ) > 0;
                this.menuAnchor = (enoughTopSpace) ? this.dropDownMenuAnchor : this.dropUpMenuAnchor;

                this.menu.setCurrentParent(this);

                HierarchySelectorDropdownButton.superclass.showMenu.call(this);

                var element = this.menu.el;
                var topLeft = element.getXY();

                if (this.menuAnchor == this.dropUpMenuAnchor && ( element.getBottom() > dropDownAnchor.getBottom()))
                    topLeft[1] += yShift;
                if (this.menuAnchor == this.dropDownMenuAnchor && ( element.getTop() < dropUpAnchor.getTop()))
                    topLeft[1] -= yShift;

                var customShifty = $( this.container.dom ).attr( "dropdown-menu-shift-y" );
                if ( customShifty )
                    topLeft[1] += parseInt( customShifty );

                element.setXY( topLeft );
                scrollWindowIfNeeded( element.dom );
            }
        }


});

Ext.reg("at_hierarchy_selector_dropdown_button", HierarchySelectorDropdownButton);

export default HierarchySelectorDropdownButton;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_hierarchy_selector_dropdown_button.js